export const trimSlash = (value) => String(value ?? '').trim().replace(/\/+$/, '')
